import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useAuth } from 'context/auth/AuthContext';

function OnlyGuestRoute({ component: Component, ...rest }) {
  const user = useAuth();
  const REDIRECT = '/dashboard';
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? <Redirect to={REDIRECT} /> : <Component {...props} />
      }
    />
  );
}

export default OnlyGuestRoute;
